/** Los cuatro tipos de página de estadísticas. */
export const resultsPage = {
    home: "home",
    competition: "competition",
    team: "team",
    match: "match",
};

/**
 * Último segmento de la URL -> tipo de página.
 * Cualquier otro slug (`primera-division.html`, `argentina-ligacopa.html`, ...) es una competición.
 */
export const pageBySlug = {
    "home.html": resultsPage.home,
    "equipo.html": resultsPage.team,
    "partido.html": resultsPage.match,
};

/** Nombres de etapa de Opta usados por las reglas de jornada (fecha). */
export const optaStage = {
    firstPhase: "1st Phase",
    secondPhase: "2nd Phase",
    regularSeason: "Regular Season",
    group: "Group",
    apertura: "Apertura",
    clausura: "Clausura",
};

/**
 * Ids de competición de Opta con reglas propias.
 * Los nombres son los que devuelve el feed `tournamentcalendar` para cada id.
 */
export const optaCompetitionId = {
    ligaProfesional: "581t4mywybx21wcpmpykhyzr3",       // Liga Profesional Argentina
    primeraNacional: "byu00jvt1j6csyv4y1lkt2fm2",       // Primera Nacional (Argentina)
    mundial: "70excpe1synn9kadnbppahdn7",               // FIFA World Cup
    copaAmerica: "45db8orh1qttbsqq9hqapmbit",           // CONMEBOL Copa America
    eliminatoriasConmebol: "2db0aw1duj2my9l5iey5gm6nq", // CONMEBOL World Cup Qualifiers
    ligaProEcuador: "6lwpjhktjhl9g7x2w7njmzva6",        // Liga Pro (Ecuador)
    mlsEstadosUnidos: "287tckirbfj9nb8ar2k9r60vn",      // US Major League Soccer
    ligaMxMexico: "2hsidwomhjsaaytdy9u5niyi4",          // Liga MX (México)
};

/**
 * Temporadas puntuales con reglas propias. Son ids de `tournamentCalendar`,
 * no de competición: identifican una edición y no el torneo.
 */
export const optaCalendarId = {
    argentinaLigaCopa: "5jc60w3y7cps00lavutor9zbo",
};

/** Equipos con trato propio en la tabla de posiciones. */
export const optaContestantId = {
    independienteRivadavia: "8inprqnxjps9ckiamn3cfoo8v",
};

/**
 * Competiciones que Opta no declara como copa pero Clarín muestra con formato de copa.
 * Se comparan contra el id de competición, que es el mismo que usa el menú del CMS.
 */
export const forcedCupCompetitionIds = [
    optaCompetitionId.mlsEstadosUnidos,
];

/** Competiciones que se muestran como fase regular aunque el feed no declare la etapa. */
export const forcedRegularSeasonCompetitionIds = [
    optaCompetitionId.ligaProEcuador
];

/**
 * La Copa de la Liga se arma sobre la 2da fase de una temporada puntual del torneo argentino.
 */
export const argentinaLigaCopa = {
    slug: "/argentina-ligacopa",
    calendarName: "2023",
    calendarId: optaCalendarId.argentinaLigaCopa,
    displayName: "Copa de la Liga",
};

